var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.billingserviceused")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            _c(
              "div",
              { staticClass: "action" },
              [
                _c("BaseDropdown", {
                  attrs: {
                    classNames: ["form-control-sm"],
                    options: _vm.dateOptions
                  },
                  on: { change: _vm.handleFilterChange },
                  model: {
                    value: _vm.date,
                    callback: function($$v) {
                      _vm.date = $$v
                    },
                    expression: "date"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "action mr-3",
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  height: "31px"
                }
              },
              _vm._l(_vm.textDiscounts, function(text, index) {
                return _c(
                  "span",
                  { key: index, staticClass: "badge badge-danger" },
                  [_vm._v("\n          " + _vm._s(text) + "\n        ")]
                )
              }),
              0
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _vm.showPricingAlert
            ? _c(
                "div",
                {
                  staticClass: "row",
                  staticStyle: { "margin-bottom": "80px" }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-info text-center",
                        staticStyle: { "margin-bottom": "-50px" },
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.pricingalertstartdate")) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("ServiceUsedSummary", {
            attrs: { data: _vm.data, apps: _vm.apps },
            on: { onOpenUsageModal: _vm.handleOpenUsageModal }
          }),
          _vm._v(" "),
          _vm.tabSelected
            ? _c("BillingInvoiceUsage", {
                attrs: {
                  dateStart: _vm.dateStart,
                  dateEnd: _vm.dateEnd,
                  records: _vm.creditRecords,
                  files: _vm.creditFiles,
                  lineMessages: _vm.creditLineMessages,
                  emails: _vm.creditEmails,
                  qrcodes: _vm.creditQRCodes,
                  branches: _vm.creditBranches,
                  warehouses: _vm.creditWarehouses,
                  users: _vm.creditUsers,
                  apps: _vm.creditApps
                },
                model: {
                  value: _vm.tabSelected,
                  callback: function($$v) {
                    _vm.tabSelected = $$v
                  },
                  expression: "tabSelected"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("BaseAppModuleListModule", {
            attrs: {
              items: _vm.usageInfoApps,
              show: _vm.usageModal.show,
              title: _vm.usageModal.title
            },
            on: { onClose: _vm.handleCloseUsageModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-067e4074", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067e4074","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/billing/serviceused/Index.vue
// module id = null
// module chunks = 